var location = window.location;



var environment = process.env.REACT_APP_ENVIRONMENT_PRODUCTION;
var domain_iframe  = process.env.REACT_APP_MOBILE_PRODUCTION_DOMAIN;
var apiurl = process.env.REACT_APP_API_ENV_PRODUCTION;

if(process.env.REACT_APP_LOCAL_DOMAIN_EN === location.origin || process.env.REACT_APP_LOCAL_DOMAIN_CA === location.origin || process.env.REACT_APP_LOCAL_DOMAIN === location.origin){
    environment = process.env.REACT_APP_ENVIRONMENT_LOCAL;
    apiurl = process.env.REACT_APP_API_ENV_LOCAL;
    domain_iframe  = process.env.REACT_APP_MOBILE_LOCAL_DOMAIN;
}else if(process.env.REACT_APP_SANDBOX_DOMAIN_CA === location.origin || process.env.REACT_APP_SANDBOX_DOMAIN_EN === location.origin){
    environment  =  process.env.REACT_APP_ENVIRONMENT_SANDBOX;
    apiurl = process.env.REACT_APP_API_ENV_SANDBOX;
    domain_iframe  = process.env.REACT_APP_MOBILE_SANDBOX_DOMAIN;
}

if(process.env.REACT_APP_ENVIRONMENT === '-sandbox'){
    environment  =  process.env.REACT_APP_ENVIRONMENT;
    apiurl = process.env.REACT_APP_API_ENV;
    domain_iframe  = process.env.REACT_APP_MOBILE_SANDBOX_DOMAIN;
}


console.log('process.env',process.env);

const config = {
    db: '',
    port: process.env.PORT || 3000,
    apiurl:apiurl, 
    basename:process.env.REACT_APP_BASENAME,
    publicurl:process.env.PUBLIC_URL+'/',
    environment:environment,
    brand:process.env.REACT_APP_BRAND,
    emailBrand:process.env.REACT_APP_EMAIL_BRAND,
    domain:location.origin,
    domain_iframe: domain_iframe
}

console.log('config',config);

module.exports = config;
